document.addEventListener("DOMContentLoaded", () => {

    const elemento = document.getElementById("texto-cupon");

    // Si el elemento no existe en la página actual, salimos de forma segura sin romper nada
    if (!elemento) return;

    elemento.addEventListener("click", async () => {
        const cupon = "MAYOMT";

        try {
            await navigator.clipboard.writeText(cupon);

            // Feedback visual simple
            elemento.classList.add("copiado");

            setTimeout(() => {
                elemento.classList.remove("copiado");
            }, 1200);

        } catch (err) {
            console.warn("No se pudo copiar automáticamente el cupón:", err);
        }
    });

});